import {css} from 'lit';
export const styles = css`:host {
  --bg: var(--contrast-light);
  --bg-hover: var(--gray-000);
  --bg-active: var(--contrast-light);

  display: block;
  border-radius: var(--border-radius);
  overflow: hidden;
}

a {
  display: flex;
  align-items: center;
  color: var(--dark-text);
  background-color: var(--bg);
}

a > * {
    margin-right: 16px;
  }

@media (hover: hover) {
    a:hover {
      color: var(--dark-text);
      background-color: var(--bg-hover);
    }
  }

a:active {
    color: var(--dark-text);
    background-color: var(--bg-active);
  }

xs-card-date-widget {
  width: 70px;
  height: 50px;
  border-radius: 0;
  background-color: var(--gray-300);

  --text-transform: capitalize;
  --dark-text-secondary: var(--dark-text);
  --day-font-size: var(--font-size-lg);
  --month-font-size: var(--font-size-lg);
}

@media (min-width: 500px) {

xs-card-date-widget {
    width: 90px
}
  }

main {
  flex: 1;
  min-width: 1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

::slotted(*) {
  margin-top: 0;
  margin-bottom: 0;
  margin-right: 16px;
  font-weight: 600;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.small-label {
  font-size: var(--font-size-sm);
  color: var(--dark-text-secondary);
}

/* TO DO: check if style written here is going to be mobile-first default */

@media (max-width: 400px) {
  main {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  ::slotted(*) {
    margin-bottom: 4px;
    margin-right: 16px;
    font-weight: 600;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    white-space: normal;
  }
}
`;
export default styles;
